import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-context-selection',
    templateUrl: './icon-context-selection.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconContextSelectionComponent {
    @Input() isActive: boolean = false;
}
